import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { Toast } from '@salesforce/design-system-react';

export class ApiErrorToast extends Component {
  getErrorLabels(error) {
    const { formatMessage } = this.props.intl;
    const { messages } = this.props.i18n;

    const { apiError, fallback } = error;
    const code = apiError && apiError.code;

    // We can handle errors at the root transl8n key or with heading and details nodes
    const heading = `common.errorToast.${code}.heading`;
    const details = `common.errorToast.${code}.details`;
    const baseError = `common.errorToast.${code}`;

    // extract additional details arguments if needed
    const context = {
      arg0:
        messages[`common.errorToast.${apiError?.details?.[0]}`] ||
        apiError?.details?.[0],
      arg1:
        messages[`common.errorToast.${apiError?.details?.[1]}`] ||
        apiError?.details?.[1]
    };

    const labels = {};
    if (messages[heading]) {
      labels.heading = formatMessage({ id: heading }, context);
    } else if (messages[baseError]) {
      labels.heading = formatMessage({ id: baseError }, context);
    } else {
      if (fallback) {
        return this.getErrorLabels(fallback);
      } else {
        // we don't know about this error, don't show the toast
        return null;
      }
    }

    // Only add details label if we have a transl8n key for it
    if (messages[details]) {
      labels.details = formatMessage({ id: details }, context);
    }
    return labels;
  }
  render() {
    if (this.props.error) {
      const labels = this.getErrorLabels(this.props.error);

      if (labels) {
        return (
          <Toast
            labels={labels}
            variant="error"
            onRequestClose={this.props.onRequestClose}
            className={this.props.className}
          />
        );
      }
    }
    return null;
  }
}

ApiErrorToast.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  i18n: PropTypes.object,
  location: PropTypes.object,
  intl: intlShape
};

export default injectIntl(ApiErrorToast);
